import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      appTitle: 'AfriHR',
      navOverview: 'Overview',
      navPeople: 'People',
      navLearning: 'Learning',
      navPayroll: 'Payroll',
      navLeaveLoans: 'Leave & Loans',
      navBenefits: 'Benefits',
      navReports: 'Reports',
      navApprovals: 'Approvals',
      navMyWorkspace: 'My Workspace',
      navAdministration: 'Administration',
      authTitle: 'HR and payroll workspace for growth-stage employers',
      authDescription: 'Sign in to manage people operations, payroll cycles, enterprise approvals, and workforce planning.',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      username: 'Username',
      password: 'Password',
      defaultAdmin: 'Default admin',
      heroTitle: 'Enterprise HR, payroll, and workforce planning in one workspace',
      heroDescription: 'Run payroll, review enterprise metrics, manage positions, and support employee self-service from one authenticated AfriHR console.',
      signedInAs: 'Signed in as',
      role: 'Role',
      activeCompany: 'Active company',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
      signOut: 'Sign Out',
      employeeManagement: 'Employee Management',
      fullName: 'Full name',
      employeeCode: 'Employee code',
      basicSalary: 'Basic salary (ETB)',
      taxableAllowance: 'Taxable allowance',
      nonTaxableAllowance: 'Non-taxable allowance',
      otherDeductions: 'Other deductions',
      department: 'Department',
      position: 'Position',
      taxId: 'Tax ID',
      accountHolderName: 'Account holder name',
      payoutMethod: 'Payout method',
      bankTransfer: 'Bank transfer',
      mobileMoney: 'Mobile money',
      bankName: 'Bank name',
      bankBranch: 'Bank branch',
      bankAccountNumber: 'Bank account number',
      mobileWalletNumber: 'Mobile wallet number',
      autopayEnabled: 'Enable scheduled autopay for this employee',
      addEmployee: 'Add Employee',
      saving: 'Saving...',
      runPayroll: 'Run Payroll',
      employee: 'Employee',
      selectEmployee: 'Select an employee',
      payrollMonth: 'Payroll month',
      calculatePayroll: 'Calculate Payroll',
      calculating: 'Calculating...',
      runMonthlyBatch: 'Run Monthly Batch',
      running: 'Running...',
      calculationResult: 'Calculation Result',
      gross: 'Gross',
      incomeTax: 'Income Tax',
      employeePension: 'Employee pension',
      employerPension: 'Employer pension',
      netPay: 'Net pay',
      latestBatchRun: 'Latest Batch Run',
      employees: 'Employees',
      general: 'General',
      salary: 'salary',
      payrollHistory: 'Payroll History',
      exportCsv: 'Export CSV',
      month: 'Month',
      allowances: 'Allowances',
      deductions: 'Deductions',
      tax: 'Tax',
      exportPayslip: 'Export Payslip PDF',
      exportErca: 'Export ERCA Excel',
      exportCostCenters: 'Export Cost Center Excel',
      exportPayouts: 'Export Payout CSV',
      bulkImport: 'Bulk Import Employees',
      chooseFile: 'Choose file',
      importTemplateHint: 'Upload CSV or Excel with employee_code, full_name, basic_salary, and optional department columns.',
      importing: 'Importing...',
      importComplete: 'Bulk import complete.',
      payslipTitle: 'Payslip',
      payrollSummary: 'Payroll Summary',
      generatedBy: 'Generated by',
      preparedOn: 'Prepared on',
      printHint: 'Your browser print dialog will open. Choose Save as PDF to export the payslip.',
      payoutStatus: 'Payout status',
      exportUnavailable: 'Run a payroll calculation before exporting a payslip.',
      noEmployees: 'No employees yet. Add one to start running payroll.',
      noHistory: 'No payroll history yet. Run the first payroll cycle to populate this section.',
      noCalculation: 'Run the calculator to see gross pay, tax, pension, and net pay.',
      userAccounts: 'User Accounts',
      createUserAccount: 'Create User Account',
      linkedEmployee: 'Linked employee',
      employeeRole: 'Employee',
      managerRole: 'Manager',
      financeRole: 'Finance',
      hrRole: 'HR',
      adminRole: 'Admin',
      selfServiceTitle: 'Self-Service Profile',
      leaveBalance: 'Leave balance',
      requestLeave: 'Request Leave',
      leaveType: 'Leave type',
      selectLeaveType: 'Select leave type',
      startDate: 'Start date',
      endDate: 'End date',
      reason: 'Reason',
      submitLeaveRequest: 'Submit Leave Request',
      myLeaveRequests: 'My Leave Requests',
      myPayrollHistory: 'My Payroll History',
      myLoans: 'My Loans',
      noLeaveRequests: 'No leave requests yet.',
      noLoans: 'No loans on record.',
      noLinkedEmployee: 'No linked employee profile is attached to this user.',
      managerApprovalQueue: 'Manager Approval Queue',
      approve: 'Approve',
      reject: 'Reject',
      enterpriseLeaveQueue: 'Enterprise Leave Queue',
      loanRegister: 'Loan Register',
      enterpriseDashboard: 'Enterprise Dashboard',
      monthlyPayrollCost: 'Monthly payroll cost',
      approvedPositions: 'Approved positions',
      vacantPositions: 'Vacant positions',
      pendingLeaves: 'Pending leaves',
      pendingApprovals: 'Pending approvals',
      headcountByDepartment: 'Headcount by department',
      payrollTrend: '12-month payroll trend',
      positions: 'Positions',
      benefitTypes: 'Benefit Types',
      benefitName: 'Benefit name',
      benefitAmount: 'Benefit amount',
      taxableBenefit: 'Taxable benefit',
      benefitFormula: 'Benefit formula',
      createBenefitType: 'Create Benefit Type',
      assignBenefit: 'Assign Benefit',
      effectiveStart: 'Effective start',
      effectiveEnd: 'Effective end',
      noBenefits: 'No benefits configured yet.',
      timesheets: 'Timesheets',
      importTimesheets: 'Import Timesheets',
      importTimesheetHint: 'Upload a ZKTeco CSV with employee code, date, clock-in, and clock-out columns.',
      noTimesheets: 'No timesheets found for the selected employee.',
      savedReports: 'Saved Reports',
      reportName: 'Name',
      reportFiltersJson: 'Filters JSON',
      reportColumns: 'Columns',
      saveReport: 'Save Report',
      noSavedReports: 'No saved reports yet.',
      apiKeys: 'Integration API Keys',
      createApiKey: 'Create Integration Key',
      noApiKeys: 'No integration API keys issued yet.',
      enableMfa: 'Enable MFA',
      mfaEnabled: 'MFA enabled',
      positionManagement: 'Position Management',
      managedPosition: 'Managed position',
      selectPosition: 'Select a position',
      jobCode: 'Job code',
      grade: 'Grade',
      headcount: 'Headcount',
      minSalary: 'Minimum salary',
      maxSalary: 'Maximum salary',
      createPosition: 'Create Position',
      noPositions: 'No approved positions yet.',
      notAvailable: 'N/A',
      english: 'English',
      amharic: 'አማርኛ',
      oromo: 'Afaan Oromoo',
    },
  },
  am: {
    translation: {
      appTitle: 'AfriHR',
      navOverview: 'አጠቃላይ እይታ',
      navPeople: 'ሰዎች',
      navLearning: 'ትምህርት',
      navPayroll: 'ደመወዝ',
      navLeaveLoans: 'ፍቃድ እና ብድር',
      navBenefits: 'ጥቅማ ጥቅሞች',
      navReports: 'ሪፖርቶች',
      navApprovals: 'ማጽደቆች',
      navMyWorkspace: 'የእኔ ቦታ',
      navAdministration: 'አስተዳደር',
      authTitle: 'ለኢትዮጵያ አሰሪዎች የደመወዝ ስርዓት',
      authDescription: 'ለሰራተኞች አስተዳደር፣ ወርሃዊ ደመወዝ ማስኬድ፣ ታሪክ መመልከት እና ሪፖርት ለመላክ ይግቡ።',
      signIn: 'ግባ',
      signingIn: 'በመግባት ላይ...',
      username: 'የተጠቃሚ ስም',
      password: 'የይለፍ ቃል',
      defaultAdmin: 'ነባሪ አስተዳዳሪ',
      heroTitle: 'ለ2025 የኢትዮጵያ የታክስ ዓመት የደመወዝ አስተዳደር',
      heroDescription: 'ሰራተኞችን ያስተዳድሩ፣ PAYE እና የጡረታ ክፍያዎችን ያስሉ፣ ወርሃዊ ሂደቶችን ያስኬዱ እና የደመወዝ ታሪክ ያውርዱ።',
      signedInAs: 'የገባው',
      role: 'ሚና',
      activeCompany: 'ንቁ ኩባንያ',
      yes: 'አዎ',
      no: 'አይ',
      active: 'ንቁ',
      inactive: 'ዝግ',
      signOut: 'ውጣ',
      employeeManagement: 'የሰራተኛ አስተዳደር',
      fullName: 'ሙሉ ስም',
      employeeCode: 'የሰራተኛ ኮድ',
      basicSalary: 'መሰረታዊ ደመወዝ (ብር)',
      taxableAllowance: 'ታክስ የሚከፈልበት አበል',
      nonTaxableAllowance: 'ከታክስ ነጻ አበል',
      otherDeductions: 'ሌሎች ቅነሳዎች',
      department: 'ክፍል',
      position: 'የስራ መደብ',
      taxId: 'የግብር መለያ',
      accountHolderName: 'የሂሳብ ባለቤት ስም',
      payoutMethod: 'የክፍያ ዘዴ',
      bankTransfer: 'የባንክ ማስተላለፊያ',
      mobileMoney: 'ሞባይል ገንዘብ',
      bankName: 'የባንክ ስም',
      bankBranch: 'የባንክ ቅርንጫፍ',
      bankAccountNumber: 'የባንክ ሂሳብ ቁጥር',
      mobileWalletNumber: 'የሞባይል ቦርሳ ቁጥር',
      autopayEnabled: 'ለዚህ ሰራተኛ የተያያዘ ራስ-ክፍያን አንቃ',
      addEmployee: 'ሰራተኛ ጨምር',
      saving: 'በማስቀመጥ ላይ...',
      runPayroll: 'ደመወዝ አስኪድ',
      employee: 'ሰራተኛ',
      selectEmployee: 'ሰራተኛ ይምረጡ',
      payrollMonth: 'የደመወዝ ወር',
      calculatePayroll: 'ደመወዝ አስላ',
      calculating: 'በማስላት ላይ...',
      runMonthlyBatch: 'ወርሃዊ ባች አስኪድ',
      running: 'በማስኬድ ላይ...',
      calculationResult: 'የሂሳብ ውጤት',
      gross: 'ጠቅላላ',
      incomeTax: 'የገቢ ግብር',
      employeePension: 'የሰራተኛ ጡረታ',
      employerPension: 'የአሰሪ ጡረታ',
      netPay: 'የተጣራ ክፍያ',
      latestBatchRun: 'የቅርብ ጊዜ የባች ሂደት',
      employees: 'ሰራተኞች',
      general: 'አጠቃላይ',
      salary: 'ደመወዝ',
      payrollHistory: 'የደመወዝ ታሪክ',
      exportCsv: 'CSV አውርድ',
      month: 'ወር',
      allowances: 'አበል',
      deductions: 'ቅነሳዎች',
      tax: 'ግብር',
      exportPayslip: 'የክፍያ ወረቀት PDF አውጣ',
      exportErca: 'የERCA Excel አውርድ',
      exportCostCenters: 'የወጪ ማዕከል Excel አውርድ',
      exportPayouts: 'የክፍያ CSV አውርድ',
      bulkImport: 'ሰራተኞችን በጅምላ አስገባ',
      chooseFile: 'ፋይል ይምረጡ',
      importTemplateHint: 'employee_code, full_name, basic_salary እና department ያላቸውን CSV ወይም Excel ፋይል ያስገቡ።',
      importing: 'በማስገባት ላይ...',
      importComplete: 'የጅምላ ማስገባት ተጠናቋል።',
      payslipTitle: 'የክፍያ ወረቀት',
      payrollSummary: 'የደመወዝ ማጠቃለያ',
      generatedBy: 'ያዘጋጀው',
      preparedOn: 'የተዘጋጀበት ቀን',
      printHint: 'የአሳሽ ማተሚያ መስኮት ይከፈታል። PDF ለማውጣት Save as PDF ይምረጡ።',
      payoutStatus: 'የክፍያ ሁኔታ',
      exportUnavailable: 'የክፍያ ወረቀት ለማውጣት መጀመሪያ የደመወዝ ሂሳብ ያስሉ።',
      noEmployees: 'እስካሁን ምንም ሰራተኛ የለም። ለመጀመሪያ ጊዜ ደመወዝ ለማስኬድ አንድ ያክሉ።',
      noHistory: 'እስካሁን የደመወዝ ታሪክ የለም። የመጀመሪያውን ዙር ያስኪዱ።',
      noCalculation: 'ጠቅላላ ክፍያ፣ ግብር፣ ጡረታ እና የተጣራ ክፍያ ለማየት አስሊው።',
      enterpriseDashboard: 'የድርጅት ዳሽቦርድ',
      monthlyPayrollCost: 'ወርሃዊ የደመወዝ ወጪ',
      approvedPositions: 'የጸደቁ የስራ መደቦች',
      vacantPositions: 'ክፍት የስራ መደቦች',
      pendingLeaves: 'በመጠባበቅ ላይ ያሉ ፈቃዶች',
      pendingApprovals: 'በመጠባበቅ ላይ ያሉ ማጽደቆች',
      headcountByDepartment: 'በክፍል የሰራተኛ ብዛት',
      payrollTrend: 'የ12 ወራት የደመወዝ አዝማሚያ',
      positions: 'የስራ መደቦች',
      benefitTypes: 'የጥቅማ ጥቅም አይነቶች',
      benefitName: 'የጥቅም ስም',
      benefitAmount: 'የጥቅም መጠን',
      taxableBenefit: 'ታክስ የሚጣልበት ጥቅም',
      benefitFormula: 'የጥቅም ቀመር',
      createBenefitType: 'የጥቅም አይነት ፍጠር',
      assignBenefit: 'ጥቅም መድብ',
      effectiveStart: 'የመጀመሪያ ቀን',
      effectiveEnd: 'የመጨረሻ ቀን',
      noBenefits: 'እስካሁን ጥቅሞች አልተመዘገቡም።',
      timesheets: 'የሰዓት መዝገቦች',
      importTimesheets: 'የሰዓት መዝገብ አስገባ',
      importTimesheetHint: 'employee code, date, clock-in, clock-out ያሉበት ZKTeco CSV ይጫኑ።',
      noTimesheets: 'ለተመረጠው ሰራተኛ የሰዓት መዝገብ የለም።',
      savedReports: 'የተቀመጡ ሪፖርቶች',
      reportName: 'ስም',
      reportFiltersJson: 'Filters JSON',
      reportColumns: 'አምዶች',
      saveReport: 'ሪፖርት አስቀምጥ',
      noSavedReports: 'የተቀመጡ ሪፖርቶች የሉም።',
      apiKeys: 'የግንኙነት API ቁልፎች',
      createApiKey: 'የግንኙነት ቁልፍ ፍጠር',
      noApiKeys: 'የግንኙነት API ቁልፎች አልተፈጠሩም።',
      enableMfa: 'MFA አስነሳ',
      mfaEnabled: 'MFA ተነስቷል',
      positionManagement: 'የስራ መደብ አስተዳደር',
      managedPosition: 'የተመዘገበ የስራ መደብ',
      selectPosition: 'የስራ መደብ ይምረጡ',
      jobCode: 'የስራ ኮድ',
      grade: 'ደረጃ',
      headcount: 'የሰራተኛ ብዛት',
      minSalary: 'ዝቅተኛ ደመወዝ',
      maxSalary: 'ከፍተኛ ደመወዝ',
      createPosition: 'የስራ መደብ ፍጠር',
      noPositions: 'እስካሁን የጸደቁ የስራ መደቦች የሉም።',
      notAvailable: 'የለም',
      // TODO(i18n-am): translate the following keys; English placeholders keep CI parity green.
      userAccounts: 'የተጠቃሚ መለያዎች',
      createUserAccount: 'የተጠቃሚ መለያ ፍጠር',
      linkedEmployee: 'የተያያዘ ሰራተኛ',
      employeeRole: 'ሰራተኛ',
      managerRole: 'ሥራ አስኪያጅ',
      financeRole: 'ፋይናንስ',
      hrRole: 'የሰው ኃይል',
      adminRole: 'አስተዳዳሪ',
      selfServiceTitle: 'የራስ አገልግሎት መገለጫ',
      leaveBalance: 'የፍቃድ ቀሪ',
      requestLeave: 'ፍቃድ ጠይቅ',
      leaveType: 'የፍቃድ አይነት',
      selectLeaveType: 'የፍቃድ አይነት ይምረጡ',
      startDate: 'የመጀመሪያ ቀን',
      endDate: 'የመጨረሻ ቀን',
      reason: 'ምክንያት',
      submitLeaveRequest: 'የፍቃድ ጥያቄ አስገባ',
      myLeaveRequests: 'የእኔ የፍቃድ ጥያቄዎች',
      myPayrollHistory: 'የእኔ የደመወዝ ታሪክ',
      myLoans: 'የእኔ ብድሮች',
      noLeaveRequests: 'እስካሁን የፍቃድ ጥያቄ የለም።',
      noLoans: 'የተመዘገበ ብድር የለም።',
      noLinkedEmployee: 'ከዚህ ተጠቃሚ ጋር የተያያዘ የሰራተኛ መገለጫ የለም።',
      managerApprovalQueue: 'የሥራ አስኪያጅ ማጽደቅ ወረፋ',
      approve: 'አጽድቅ',
      reject: 'ውድቅ አድርግ',
      enterpriseLeaveQueue: 'የድርጅት ፍቃድ ወረፋ',
      loanRegister: 'የብድር መዝገብ',
      english: 'English',
      amharic: 'አማርኛ',
      oromo: 'Afaan Oromoo',
    },
  },
  om: {
    translation: {
      appTitle: 'AfriHR',
      navOverview: 'Waliigala',
      navPeople: 'Namoota',
      navLearning: 'Barnoota',
      navPayroll: 'Mindaa',
      navLeaveLoans: 'Boqonnaa fi Liqii',
      navBenefits: 'Faayidaa',
      navReports: 'Gabaasa',
      navApprovals: 'Mirkaneessuu',
      navMyWorkspace: 'Iddoo Koo',
      navAdministration: 'Bulchiinsa',
      authTitle: 'Sirna mindaa hojii ittiin bulchan daldaltoota Itoophiyaa',
      authDescription: 'Hojjettoota bulchuuf, mindaa ji\'aa raawwachuuf, seenaa ilaaluuf fi gabaasa baasuuuf seenaa keessa seeni.',
      signIn: 'Seeni',
      signingIn: 'Seenaa keessa jira...',
      username: 'Maqaa fayyadamaa',
      password: 'Jecha iccitii',
      defaultAdmin: 'Bulchaa durtii',
      heroTitle: 'Hojii mindaa bara gibiraa Itoophiyaa 2025',
      heroDescription: 'Hojjettoota bulchi, PAYE fi gumaacha piroovidentii shallagi, batch ji\'aa raawwadhu, fi seenaa mindaa ergi.',
      signedInAs: 'Kan seene',
      role: 'Gahee hojii',
      activeCompany: 'Dhaabbata hojii filatame',
      yes: 'Eeyyee',
      no: 'Lakki',
      active: 'Hojii irra',
      inactive: 'Dhaabbate',
      signOut: 'Ba\'i',
      employeeManagement: 'Bulchiinsa hojjettootaa',
      fullName: 'Maqaa guutuu',
      employeeCode: 'Koodii hojjetaa',
      basicSalary: 'Mindaa bu\'uuraa (ETB)',
      taxableAllowance: 'Dabalata gibirri irra jiru',
      nonTaxableAllowance: 'Dabalata gibirri irraa bilisa',
      otherDeductions: 'Hir\'inoota biraa',
      department: 'Kutaa',
      position: 'Iddoo hojii',
      taxId: 'Eenyummeessa gibiraa',
      accountHolderName: 'Maqaa abbaa herregaa',
      payoutMethod: 'Mala kaffaltii',
      bankTransfer: 'Dabarsa baankii',
      mobileMoney: 'Maallaqa moobaayilaa',
      bankName: 'Maqaa baankii',
      bankBranch: 'Damee baankii',
      bankAccountNumber: 'Lakkoofsa herrega baankii',
      mobileWalletNumber: 'Lakkoofsa boorsaa moobaayilaa',
      autopayEnabled: 'Hojjetaa kanaaf kaffaltii ofumaan raawwatamu dandeessisi',
      addEmployee: 'Hojjetaa dabali',
      saving: 'Kuusaa jira...',
      runPayroll: 'Mindaa raawwadhu',
      employee: 'Hojjetaa',
      selectEmployee: 'Hojjetaa filadhu',
      payrollMonth: 'Ji\'a mindaa',
      calculatePayroll: 'Mindaa shallagi',
      calculating: 'Shallagaa jira...',
      runMonthlyBatch: 'Batch ji\'aa raawwadhu',
      running: 'Raawwachaa jira...',
      calculationResult: 'Bu\'aa shallagaa',
      gross: 'Waliigala',
      incomeTax: 'Gibira galii',
      employeePension: 'Piroovidentii hojjetaa',
      employerPension: 'Piroovidentii hojjechiisaa',
      netPay: 'Kaffaltii qulqulluu',
      latestBatchRun: 'Raawwii batch isa dhumaa',
      employees: 'Hojjettoota',
      general: 'Waliigalaa',
      salary: 'mindaa',
      payrollHistory: 'Seenaa mindaa',
      exportCsv: 'CSV baasi',
      month: 'Ji\'a',
      allowances: 'Dabalata',
      deductions: 'Hir\'inoota',
      tax: 'Gibira',
      exportPayslip: 'Payslip PDF baasi',
      exportErca: 'Excel ERCA baasi',
      exportCostCenters: 'Excel cost center baasi',
      exportPayouts: 'CSV kaffaltii baasi',
      bulkImport: 'Hojjettoota walitti galchi',
      chooseFile: 'Faayila filadhu',
      importTemplateHint: 'CSV ykn Excel employee_code, full_name, basic_salary, fi department of keessaa qabaatu olkaa’i.',
      importing: 'Galchaa jira...',
      importComplete: 'Galchiinsi walitti qabame xumurameera.',
      payslipTitle: 'Payslip',
      payrollSummary: 'Cuunfaa mindaa',
      generatedBy: 'Kan qopheesse',
      preparedOn: 'Guyyaa qophaa\'e',
      printHint: 'Qabduun maxxansaa browser keetii ni banama. PDF baasuuf Save as PDF filadhu.',
      payoutStatus: 'Haala kaffaltii',
      exportUnavailable: 'Payslip baasuu dura shallaggii mindaa tokko raawwadhu.',
      noEmployees: 'Hanga ammaatti hojjetaan hin jiru. Jalqabuuf tokko dabaluu qabda.',
      noHistory: 'Seenaa mindaa hin jiru. Marsaa jalqabaa raawwadhu.',
      noCalculation: 'Waliigala, gibira, piroovidentii fi kaffaltii qulqulluu arguuf shallagi.',
      enterpriseDashboard: 'Daashboordii dhaabbataa',
      monthlyPayrollCost: 'Baasiin mindaa jiʼaa',
      approvedPositions: 'Iddoowwan hojii mirkanaaʼan',
      vacantPositions: 'Iddoowwan hojii banaa',
      pendingLeaves: 'Hayyamoonni eegaa jiran',
      pendingApprovals: 'Mirkaneeffannoowwan eegaa jiran',
      headcountByDepartment: 'Baayʼina hojjettootaa kutaa irratti',
      payrollTrend: 'Haala mindaa jiʼoota 12',
      positions: 'Iddoowwan hojii',
      benefitTypes: 'Gosoota faayidaa',
      benefitName: 'Maqaa faayidaa',
      benefitAmount: 'Hamma faayidaa',
      taxableBenefit: 'Faayidaa gibira qabu',
      benefitFormula: 'Foormulaa faayidaa',
      createBenefitType: 'Gosa faayidaa uumi',
      assignBenefit: 'Faayidaa ramadi',
      effectiveStart: 'Guyyaa jalqabaa',
      effectiveEnd: 'Guyyaa xumuraa',
      noBenefits: 'Faayidaan hanga ammaatti hin jiru.',
      timesheets: 'Galmee sa\'aa',
      importTimesheets: 'Galmee sa\'aa galchi',
      importTimesheetHint: 'CSV ZKTeco employee code, date, clock-in, fi clock-out qabu olkaa\'i.',
      noTimesheets: 'Hojjetaa filatameef galmeen sa\'aa hin argamne.',
      savedReports: 'Gabaasota kuufaman',
      reportName: 'Maqaa',
      reportFiltersJson: 'Filters JSON',
      reportColumns: 'Tarreewwan',
      saveReport: 'Gabaasa kuusi',
      noSavedReports: 'Gabaasni kuufame hin jiru.',
      apiKeys: 'Furtuulee API walitti-hidhamiinsaa',
      createApiKey: 'Furtuu walitti-hidhamiinsaa uumi',
      noApiKeys: 'Furtuun API walitti-hidhamiinsaa hin uumamne.',
      enableMfa: 'MFA hojii irra oolchi',
      mfaEnabled: 'MFA hojii irra jira',
      positionManagement: 'Bulchiinsa iddoo hojii',
      managedPosition: 'Iddoo hojii galmaaʼe',
      selectPosition: 'Iddoo hojii filadhu',
      jobCode: 'Koodii hojii',
      grade: 'Sadarkaa',
      headcount: 'Baayʼina namaa',
      minSalary: 'Mindaa gadi aanaa',
      maxSalary: 'Mindaa ol aanaa',
      createPosition: 'Iddoo hojii uumi',
      noPositions: 'Ammaaf iddoowwan hojii mirkanaaʼan hin jiran.',
      notAvailable: 'Hin jiru',
      // TODO(i18n-om): translate the following keys; English placeholders keep CI parity green.
      userAccounts: 'User Accounts',
      createUserAccount: 'Create User Account',
      linkedEmployee: 'Linked employee',
      employeeRole: 'Employee',
      managerRole: 'Manager',
      financeRole: 'Finance',
      hrRole: 'HR',
      adminRole: 'Admin',
      selfServiceTitle: 'Self-Service Profile',
      leaveBalance: 'Leave balance',
      requestLeave: 'Request Leave',
      leaveType: 'Leave type',
      selectLeaveType: 'Select leave type',
      startDate: 'Start date',
      endDate: 'End date',
      reason: 'Reason',
      submitLeaveRequest: 'Submit Leave Request',
      myLeaveRequests: 'My Leave Requests',
      myPayrollHistory: 'My Payroll History',
      myLoans: 'My Loans',
      noLeaveRequests: 'No leave requests yet.',
      noLoans: 'No loans on record.',
      noLinkedEmployee: 'No linked employee profile is attached to this user.',
      managerApprovalQueue: 'Manager Approval Queue',
      approve: 'Approve',
      reject: 'Reject',
      enterpriseLeaveQueue: 'Enterprise Leave Queue',
      loanRegister: 'Loan Register',
      english: 'English',
      amharic: 'አማርኛ',
      oromo: 'Afaan Oromoo',
    },
  },
};

const enterpriseKeys = {
  en: {
    navEnterprise: 'Enterprise', navExpenses: 'Expenses',
    notifications: 'Notifications', markAllRead: 'Mark all read', noNotifications: 'No notifications yet.', markRead: 'Mark read',
    expenseClaims: 'Expense Claims', title: 'Title', category: 'Category', amount: 'Amount', expenseDate: 'Expense date',
    submitExpense: 'Submit Expense', noExpenses: 'No expense claims yet.', reimburse: 'Reimburse',
    assetRegister: 'Asset Register', assetTag: 'Asset tag', assetName: 'Asset name', purchaseCost: 'Purchase cost',
    addAsset: 'Add Asset', noAssets: 'No assets recorded.', assignedTo: 'Assigned to', returnAsset: 'Return', assign: 'Assign',
    orgChart: 'Org Chart', reportsTo: 'Reports to', noManager: 'No manager (top level)', setManager: 'Set Manager', noOrgData: 'No employees to display.',
    shiftScheduling: 'Shift Scheduling', shiftName: 'Shift name', startTime: 'Start time', endTime: 'End time', nightShift: 'Night shift',
    addShiftTemplate: 'Add Shift', shift: 'Shift', selectShift: 'Select a shift', workDate: 'Work date', scheduleShift: 'Schedule Shift', noShifts: 'No shifts scheduled.',
    contracts: 'Contracts', contractsExpiringSoon: '{{count}} contract(s) expiring within 60 days', contractType: 'Contract type', monthlySalary: 'Monthly salary',
    addContract: 'Add Contract', noContracts: 'No contracts recorded.', sign: 'Sign', signed: 'Signed', signerNamePrompt: 'Enter the signer full name',
    offboarding: 'Offboarding & Final Settlement', lastWorkingDate: 'Last working date', previewSettlement: 'Preview Settlement', initiateOffboarding: 'Initiate Offboarding',
    settlementPreview: 'Settlement Preview', yearsOfService: 'Years of service', severance: 'Severance', noticePay: 'Notice pay', leavePayout: 'Unused leave payout',
    totalSettlement: 'Total settlement', noOffboarding: 'No offboarding cases.', completeOffboarding: 'Complete',
    disciplinary: 'Disciplinary & Grievance', severity: 'Severity', summary: 'Summary', openCase: 'Open Case', noDisciplinary: 'No cases recorded.', resolve: 'Resolve', resolutionPrompt: 'Enter resolution note',
    workforceAnalytics: 'Workforce Analytics', loading: 'Loading...', attritionRate: 'Attrition rate', avgTenure: 'Avg tenure (yrs)', annualPayrollCost: 'Annual payroll cost', terminationsYtd: 'Terminations YTD',
    compliance: 'Compliance & Filing', todayEthiopian: 'Today (Ethiopian)', morExportHint: 'Export the Ministry of Revenue PAYE/pension declaration for the active company.', exportMorDeclaration: 'Export MoR Declaration',
  },
  am: {
    navEnterprise: 'ድርጅት', navExpenses: 'ወጪዎች',
    notifications: 'ማሳወቂያዎች', markAllRead: 'ሁሉንም እንደተነበበ ምልክት አድርግ', noNotifications: 'እስካሁን ማሳወቂያ የለም።', markRead: 'እንደተነበበ ምልክት አድርግ',
    expenseClaims: 'የወጪ ጥያቄዎች', title: 'ርዕስ', category: 'ምድብ', amount: 'መጠን', expenseDate: 'የወጪ ቀን',
    submitExpense: 'ወጪ አስገባ', noExpenses: 'እስካሁን የወጪ ጥያቄ የለም።', reimburse: 'መልስ ክፈል',
    assetRegister: 'የንብረት መዝገብ', assetTag: 'የንብረት መለያ', assetName: 'የንብረት ስም', purchaseCost: 'የግዢ ዋጋ',
    addAsset: 'ንብረት ጨምር', noAssets: 'የተመዘገበ ንብረት የለም።', assignedTo: 'የተመደበለት', returnAsset: 'መልስ', assign: 'መድብ',
    orgChart: 'የድርጅት መዋቅር', reportsTo: 'የሚያሳውቀው ለ', noManager: 'ኃላፊ የለም (ከፍተኛ ደረጃ)', setManager: 'ኃላፊ አዘጋጅ', noOrgData: 'የሚታይ ሰራተኛ የለም።',
    shiftScheduling: 'የፈረቃ መርሐግብር', shiftName: 'የፈረቃ ስም', startTime: 'የመጀመሪያ ሰዓት', endTime: 'የመጨረሻ ሰዓት', nightShift: 'የሌሊት ፈረቃ',
    addShiftTemplate: 'ፈረቃ ጨምር', shift: 'ፈረቃ', selectShift: 'ፈረቃ ይምረጡ', workDate: 'የስራ ቀን', scheduleShift: 'ፈረቃ መድብ', noShifts: 'የተመደበ ፈረቃ የለም።',
    contracts: 'ውሎች', contractsExpiringSoon: '{{count}} ውል በ60 ቀናት ውስጥ ያበቃል', contractType: 'የውል አይነት', monthlySalary: 'ወርሃዊ ደመወዝ',
    addContract: 'ውል ጨምር', noContracts: 'የተመዘገበ ውል የለም።', sign: 'ፈርም', signed: 'ተፈርሟል', signerNamePrompt: 'የፈራሚውን ሙሉ ስም ያስገቡ',
    offboarding: 'ስንብት እና የመጨረሻ ክፍያ', lastWorkingDate: 'የመጨረሻ የስራ ቀን', previewSettlement: 'ክፍያ ቅድመ እይታ', initiateOffboarding: 'ስንብት ጀምር',
    settlementPreview: 'የክፍያ ቅድመ እይታ', yearsOfService: 'የአገልግሎት ዓመታት', severance: 'የስንብት ክፍያ', noticePay: 'የማስጠንቀቂያ ክፍያ', leavePayout: 'ያልተጠቀመ ፍቃድ ክፍያ',
    totalSettlement: 'ጠቅላላ ክፍያ', noOffboarding: 'የስንብት ጉዳዮች የሉም።', completeOffboarding: 'አጠናቅቅ',
    disciplinary: 'ተግሣጽ እና ቅሬታ', severity: 'ክብደት', summary: 'ማጠቃለያ', openCase: 'ጉዳይ ክፈት', noDisciplinary: 'የተመዘገበ ጉዳይ የለም።', resolve: 'ፍታ', resolutionPrompt: 'የመፍትሄ ማስታወሻ ያስገቡ',
    workforceAnalytics: 'የሰው ኃይል ትንተና', loading: 'በመጫን ላይ...', attritionRate: 'የመልቀቅ መጠን', avgTenure: 'አማካይ የቆይታ ዓመት', annualPayrollCost: 'ዓመታዊ የደመወዝ ወጪ', terminationsYtd: 'የዓመቱ ስንብቶች',
    compliance: 'ተገዢነት እና ሪፖርት', todayEthiopian: 'ዛሬ (ኢትዮጵያ)', morExportHint: 'ለንቁ ኩባንያ የገቢዎች ሚኒስቴር PAYE/ጡረታ መግለጫ ያውጡ።', exportMorDeclaration: 'የገቢዎች መግለጫ አውጣ',
  },
  om: {
    navEnterprise: 'Dhaabbata', navExpenses: 'Baasii',
    notifications: 'Beeksisa', markAllRead: 'Hunda akka dubbifame mallattoo', noNotifications: 'Beeksisni hin jiru.', markRead: 'Akka dubbifame',
    expenseClaims: 'Gaaffii Baasii', title: 'Mata duree', category: 'Ramaddii', amount: 'Baay\'ina', expenseDate: 'Guyyaa baasii',
    submitExpense: 'Baasii galchi', noExpenses: 'Gaaffiin baasii hin jiru.', reimburse: 'Deebisi',
    assetRegister: 'Galmee Qabeenyaa', assetTag: 'Mallattoo qabeenyaa', assetName: 'Maqaa qabeenyaa', purchaseCost: 'Gatii bittaa',
    addAsset: 'Qabeenya dabali', noAssets: 'Qabeenyi hin galmoofne.', assignedTo: 'Kan kennameef', returnAsset: 'Deebisi', assign: 'Ramadi',
    orgChart: 'Caasaa Dhaabbataa', reportsTo: 'Kan gabaasu', noManager: 'Bulchaa hin qabu', setManager: 'Bulchaa qopheessi', noOrgData: 'Hojjetaan agarsiifamu hin jiru.',
    shiftScheduling: 'Sagantaa Shiftii', shiftName: 'Maqaa shiftii', startTime: 'Sa\'aa jalqabaa', endTime: 'Sa\'aa xumuraa', nightShift: 'Shiftii halkanii',
    addShiftTemplate: 'Shiftii dabali', shift: 'Shiftii', selectShift: 'Shiftii filadhu', workDate: 'Guyyaa hojii', scheduleShift: 'Shiftii ramadi', noShifts: 'Shiftiin hin ramadamne.',
    contracts: 'Waliigaltee', contractsExpiringSoon: 'Waliigalteen {{count}} guyyaa 60 keessatti raawwata', contractType: 'Gosa waliigaltee', monthlySalary: 'Mindaa ji\'aa',
    addContract: 'Waliigaltee dabali', noContracts: 'Waliigalteen hin galmoofne.', sign: 'Mallatteessi', signed: 'Mallatteeffame', signerNamePrompt: 'Maqaa guutuu mallatteessaa galchi',
    offboarding: 'Ba\'umsaa fi Kaffaltii Xumuraa', lastWorkingDate: 'Guyyaa hojii dhumaa', previewSettlement: 'Kaffaltii ilaali', initiateOffboarding: 'Ba\'umsa jalqabi',
    settlementPreview: 'Ilaalcha Kaffaltii', yearsOfService: 'Waggaa tajaajilaa', severance: 'Kaffaltii ba\'umsaa', noticePay: 'Kaffaltii beeksisaa', leavePayout: 'Kaffaltii boqonnaa hin fayyadamne',
    totalSettlement: 'Kaffaltii waliigalaa', noOffboarding: 'Dhimmi ba\'umsaa hin jiru.', completeOffboarding: 'Xumuri',
    disciplinary: 'Naamusaa fi Komii', severity: 'Cimina', summary: 'Cuunfaa', openCase: 'Dhimma bani', noDisciplinary: 'Dhimmi hin galmoofne.', resolve: 'Furi', resolutionPrompt: 'Yaadannoo furmaataa galchi',
    workforceAnalytics: 'Xiinxala Humna Namaa', loading: 'Fe\'aa jira...', attritionRate: 'Sadarkaa ba\'umsaa', avgTenure: 'Giddu-galeessa waggaa', annualPayrollCost: 'Baasii mindaa waggaa', terminationsYtd: 'Ba\'umsa waggaa',
    compliance: 'Ulaagaa fi Gabaasa', todayEthiopian: 'Har\'a (Itoophiyaa)', morExportHint: 'Dhaabbata filatameef ibsa PAYE/penshinii Ministeera Galiiwwanii baasi.', exportMorDeclaration: 'Ibsa MoR baasi',
  },
};

Object.assign(resources.en.translation, enterpriseKeys.en);
Object.assign(resources.am.translation, enterpriseKeys.am);
Object.assign(resources.om.translation, enterpriseKeys.om);

i18n.use(initReactI18next).init({
  resources,
  lng: window.localStorage.getItem('afrihr.lang') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
i18n.on('languageChanged', (language) => {
  window.localStorage.setItem('afrihr.lang', language);
});

export default i18n;